export const SparklesIcon = ({
  color,
  full,
  className,
}: {
  color?: string
  full?: boolean
  className?: string
}) => {
  const fillColor = color ?? '#3643BA'

  if (full) {
    return (
      <svg
        width="13"
        height="14"
        viewBox="0 0 13 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.33352 2.67432L7.80075 3.90083C8.44705 5.59745 9.73601 6.88641 11.4327 7.53278L12.6592 8.00003L11.4327 8.46727C9.73601 9.11364 8.44705 10.4026 7.80075 12.0992L7.33352 13.3257L6.86626 12.0992C6.21989 10.4026 4.93093 9.11364 3.23427 8.46727L2.00781 8.00003L3.23427 7.53279C4.93093 6.88641 6.21989 5.59745 6.86626 3.90081L7.33352 2.67432Z"
          fill={fillColor}
          className="dy-muse-widget__spark dy-muse-widget__spark--1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.57824 4.36936C3.54813 4.71273 2.63249 5.62836 2.28912 6.65849C1.94575 5.62836 1.0301 4.71273 0 4.36936C1.0301 4.02599 1.94575 3.11035 2.28912 2.08024C2.63249 3.11035 3.54813 4.02599 4.57824 4.36936Z"
          fill={fillColor}
          className="dy-muse-widget__spark dy-muse-widget__spark--2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.98265 1.37347C6.41032 1.60239 5.83805 2.06021 5.60918 2.74695C5.38025 2.06021 4.80796 1.60239 4.23568 1.37347C4.92242 1.14456 5.38025 0.57228 5.60918 0C5.83805 0.57228 6.41032 1.03011 6.98265 1.37347Z"
          fill={fillColor}
          className="dy-muse-widget__spark dy-muse-widget__spark--3"
        />
      </svg>
    )
  }

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        className="dy-muse-widget__spark dy-muse-widget__spark--1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.6669 4.01144L9.13412 5.23796C9.78043 6.93457 11.0694 8.22354 12.7661 8.86991L13.9926 9.33715L12.7661 9.8044C11.0694 10.4508 9.78043 11.7397 9.13412 13.4363L8.6669 14.6629L8.19964 13.4364C7.55326 11.7397 6.2643 10.4508 4.56765 9.8044L3.34119 9.33715L4.56765 8.86991C6.2643 8.22354 7.55326 6.93457 8.19964 5.23794L8.6669 4.01144ZM5.92281 9.33716C7.07761 9.98594 8.01808 10.9264 8.66686 12.0812C9.31562 10.9264 10.2561 9.98594 11.4109 9.33716C10.2561 8.68837 9.31562 7.74792 8.66686 6.59312C8.01808 7.74791 7.07761 8.68837 5.92281 9.33716Z"
        fill={fillColor}
      />
      <path
        className="dy-muse-widget__spark dy-muse-widget__spark--2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.91161 5.70649C4.88151 6.04986 3.96586 6.96549 3.62249 7.99562C3.27913 6.96549 2.36347 6.04986 1.33337 5.70649C2.36347 5.36312 3.27913 4.44748 3.62249 3.41737C3.96586 4.44748 4.88151 5.36312 5.91161 5.70649Z"
        fill={fillColor}
      />
      <path
        className="dy-muse-widget__spark dy-muse-widget__spark--3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.31602 2.7106C7.74369 2.93951 7.17142 3.39733 6.94256 4.08407C6.71362 3.39733 6.14133 2.93951 5.56905 2.7106C6.25579 2.48169 6.71362 1.90941 6.94256 1.33713C7.17142 1.90941 7.74369 2.36723 8.31602 2.7106Z"
        fill={fillColor}
      />
    </svg>
  )
}
